import { merge } from 'lodash';
import axios from 'axios';
import config from './config';
import settings from './settings';

const VISUALS_ID = '9b4e04738493129a956e5da219fb3eda';
const VISUALS_LIVE_BETTING_LION_ID = '0b094ccea995c785d9caa80c9ba6ced0';

const http = axios.create({
  baseURL: config.API.tc[settings.env],
  timeout: 10000,
});

const languageMapper = {
  sr_latn: 'sr',
  sr_cyrl: 'sr',
  'sr-latn': 'sr',
  'sr-cyrl': 'sr',
};

const getUrl = (projectId, language, companyUuid) => {
  const formattedLanguage = languageMapper[language.toLowerCase()] || language;
  const projectsLocale = `/translations/${projectId}/locales/${formattedLanguage}`;
  const tenantLocale = companyUuid ? `${projectsLocale}/tenants/${companyUuid}` : projectsLocale;

  return `${tenantLocale}?includeLocaleFallback=true`;
};

export default {
  get(language) {
    const visualsUrl = getUrl(VISUALS_ID, language, settings.company.uuid);
    const visualsLiveBettingUrl = getUrl(
      VISUALS_LIVE_BETTING_LION_ID,
      language,
      settings.company.uuid,
    );

    return axios.all([
      http.get(visualsUrl),
      http.get(visualsLiveBettingUrl),
    ]).then((response) => {
      const translations = merge({}, response[0].data, response[1].data);
      return translations;
    });
  },
};
